@if (hasExtendedActions() && (actions.book || !isElementProtected())) {
    <div class="PGResourceElementMenu"
        ngbDropdown #dropdown="ngbDropdown" [autoClose]="'outside'" (click)="$event.stopPropagation();" (openChange)="onOpenChange($event)">
        @if (isRunningAction) {
            <app-pg-loading [isOverlay]="true"></app-pg-loading>
        }
        <button ngbDropdownToggle class="btn btn-white">
            @if (isLarge) {
                <span class="me-2">{{ 'pg-resource-element-menu.button' | locTranslate }}</span>
            }
            <i class="fa-regular fa-ellipsis-v"></i>
        </button>
        <div ngbDropdownMenu class="PGResourceElementMenu-Menu" (click)="dropdown.close();">
            @if (!showMoreProperties) {
                <div [appPgAnimations]="showMoreProperties == null ? null : 'EnterL'">
                    @if (elementData.published && actions.book) {
                        @if (!elementData.bookable) {
                            <div class="dropdown-item disabled">
                                <i class="fa-regular fa-book"></i><span>{{ 'pg-resource-element-menu.not-bookable' | locTranslate }}</span>
                            </div>
                        }
                        @else {
                            <div class="dropdown-item" (click)="runAction('book')">
                                <i class="fa-regular fa-book"></i><span>{{ getActionLabel('book') | locTranslate }}</span>
                            </div>
                        }
                        <div class="dropdown-divider"></div>
                    }
                    @if (!isElementProtected()) {
                        <ng-content select="[beforeEdit]"></ng-content>
                        @if (actions.edit) {
                            <div class="dropdown-item" (click)="runAction('edit')">
                                <i class="fa-regular fa-edit"></i><span>{{ getActionLabel('edit') | locTranslate }}</span>
                            </div>
                        }
                        @if (actions.copy) {
                            <div class="dropdown-item" (click)="runAction('copy')">
                                <i class="fa-regular fa-copy"></i><span>{{ getActionLabel('copy') | locTranslate }}</span>
                            </div>
                        }
                        @if (actions.delete) {
                            <app-pg-confirm-action (confirmed)="runAction('delete')">
                                <div class="dropdown-item text-danger">
                                    <i class="fa-regular fa-trash"></i><span>{{ getActionLabel('delete') | locTranslate }}</span>
                                </div>
                            </app-pg-confirm-action>
                        }
                        <ng-content select="[afterEdit]"></ng-content>
                        <div class="dropdown-divider"></div>
                        @if (actions.book && canEditField('bookable')) {
                            <div class="dropdown-item d-flex justify-content-between align-items-center" (click)="runAction('bookable', !elementData.bookable)">
                                <div>
                                    <i class="fa-regular fa-book"></i><span>{{ 'pg-resource-element-menu.toggle-bookable' | locTranslate }}</span>
                                </div>
                                <div class="ps-2">
                                    <app-pg-switch [small]="true" [ngModel]="elementData.bookable"></app-pg-switch>
                                </div>
                            </div>
                        }
                        @if (actions.publish && canEditField('published')) {
                            @if (!elementData.published && !canBePublished()) {
                                <div class="dropdown-item disabled">
                                    <i class="fa-regular fa-eye"></i><span>{{ 'pg-resource-element-menu.not-publishable' | locTranslate }}</span>
                                </div>
                            }
                            @if (elementData.published || canBePublished()) {
                                <div class="dropdown-item d-flex justify-content-between align-items-center" (click)="runAction('published', !elementData.published)">
                                    <div>
                                        <i class="fa-regular fa-eye"></i><span>{{ 'pg-resource-element-menu.toggle-published' | locTranslate }}</span>
                                    </div>
                                    <div class="ps-2">
                                        <app-pg-switch [small]="true" [ngModel]="elementData.published"></app-pg-switch>
                                    </div>
                                </div>
                            }
                        }
                        @if(canBeVisitCardSupplier() && canEditField('visit_card_supplier')) {
                            <div class="dropdown-item d-flex justify-content-between align-items-center" (click)="runAction('visit_card_supplier', !elementData.visit_card_supplier)">
                                <div>
                                    <i class="fa-regular fa-qrcode"></i><span>{{ 'pg-resource-element-menu.toggle-visit_card_supplier' | locTranslate }}</span>
                                </div>
                                <div class="ps-2">
                                    <app-pg-switch [small]="true" [ngModel]="elementData.visit_card_supplier"></app-pg-switch>
                                </div>
                            </div>
                        }
                        @if (actions.by_organization && canEditField('by_organization') && canBeByOrganization()) {
                            <div class="dropdown-item d-flex justify-content-between align-items-center" (click)="runAction('by_organization', !elementData.by_organization)">
                                <div>
                                    <i class="fa-regular fa-certificate"></i><span>{{ 'pg-resource-element-menu.toggle-by_organization' | locTranslate }}</span>
                                </div>
                                <div class="ps-2">
                                    <app-pg-switch [small]="true" [ngModel]="elementData.by_organization"></app-pg-switch>
                                </div>
                            </div>
                        }
                        @if (actions.event_organizer && canEditField('event_organizer') && canBeEventOrganizer()) {
                            <div class="dropdown-item d-flex justify-content-between align-items-center" (click)="runAction('event_organizer', !elementData.event_organizer)">
                                <div>
                                    <i class="fa-regular fa-calendar-star"></i><span>{{ 'pg-resource-element-menu.toggle-event_organizer' | locTranslate }}</span>
                                </div>
                                <div class="ps-2">
                                    <app-pg-switch [small]="true" [ngModel]="elementData.event_organizer"></app-pg-switch>
                                </div>
                            </div>
                        }
                        @for (connector of ['TDH','DHM']; track connector) {
                            @if (canPublishOn(connector)) {
                                @if (!canElementBePublishedOn(connector)) {
                                    <div class="dropdown-item disabled">
                                        <i class="fa-regular fa-eye"></i><span>{{ 'pg-resource-element-menu.not-connector-publishable' | locTranslate:'connector':connector }}</span>
                                    </div>
                                }
                                @else {
                                    <div class="dropdown-item d-flex justify-content-between" (click)="runAction('connector-publish', true, connector)">
                                        <div>
                                            <div class="d-flex">
                                                <div>
                                                    <i class="fa-regular fa-cloud-arrow-up"></i>
                                                </div>
                                                <div>
                                                    <div>
                                                        <span>{{ 'pg-resource-element-menu.connector-publish' | locTranslate:'connector':connector }}</span>
                                                    </div>
                                                    @if (getLastPublished(connector); as date) {
                                                        <div class="small">
                                                            <span class="text-muted">{{ 'pg-resource-element-menu.connector-last-published' | locTranslate }} {{date | locFormat:'datetime'}}</span>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                            @if (hasPublishWarning(connector)) {
                                                <div class="mt-1">
                                                    <small class="alert alert-warning m-0 px-2 py-1 text-wrap">{{ 'pg-resource-element-menu.warning-connector-publish' | locTranslate:'connector':connector }}</small>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                }
                            }
                        }
                        @if (canEditField('template')) {
                            <div class="dropdown-divider"></div>
                            <div class="dropdown-item" (click)="runAction('template')">
                                <i class="fa-regular fa-table"></i><span>{{ getActionLabel('template') | locTranslate }}</span>
                            </div>
                        }
                        @if (hasMoreProperties()) {
                            <div class="dropdown-divider"></div>
                            <div class="dropdown-item" (click)="showMoreProperties = true; $event.stopPropagation();">
                                <i class="fa-regular fa-ellipsis"></i><span>{{ 'pg-resource-element-menu.more-properties' | locTranslate }}</span>
                            </div>
                        }
                    }
                </div>
            }
            @if (showMoreProperties) {
                <div [appPgAnimations]="'EnterR'">
                    <div class="dropdown-item" (click)="showMoreProperties = false; $event.stopPropagation();">
                        <i class="fa-regular fa-chevron-left"></i><span>{{ 'pg-resource-element-menu.more-properties-back' | locTranslate }}</span>
                    </div>
                    <div class="dropdown-divider"></div>
                    @if (canEditField('category')) {
                        <div class="dropdown-item d-flex justify-content-between" (click)="runAction('category', elementData.category)">
                            <div>
                                <i class="fa-regular fa-list"></i><span>{{ 'RESOURCES.' + getCleanResourceId() + '.fields.category.label' | locTranslate  }}</span>
                            </div>
                            <div>
                                <b class="ps-3">{{ getCategoryLabel(elementData.category) || '-' }}</b>
                            </div>
                        </div>
                    }
                    @if (canEditField('categories')) {
                        <div class="dropdown-item d-flex justify-content-between" (click)="runAction('categories', elementData.categories)">
                            <div>
                                <i class="fa-regular fa-list"></i><span>{{ 'RESOURCES.' + getCleanResourceId() + '.fields.categories.label' | locTranslate  }}</span>
                            </div>
                            <div>
                                <b class="ps-3">{{ getCategoriesLabel(elementData.categories) || '-' }}</b>
                            </div>
                        </div>
                    }
                    @if (canEditField('system_tags')) {
                        <div class="dropdown-item d-flex justify-content-between" (click)="runAction('system_tags', elementData.system_tags)">
                            <div>
                                <i class="fa-regular fa-hashtag-lock"></i><span>{{ 'RESOURCES.' + getCleanResourceId() + '.fields.system_tags.label' | locTranslate  }}</span>
                            </div>
                            <div>
                                <b class="ps-3">{{ getSystemTagsLabel(elementData.system_tags) || '-' }}</b>
                            </div>
                        </div>
                    }
                    @if (canEditField('tags')) {
                        <div class="dropdown-item d-flex justify-content-between" (click)="runAction('tags', elementData.tags)">
                            <div>
                                <i class="fa-regular fa-hashtag"></i><span>{{ 'RESOURCES.' + getCleanResourceId() + '.fields.tags.label' | locTranslate  }}</span>
                            </div>
                            <div>
                                <b class="ps-3">{{ elementData.tags || '-' }}</b>
                            </div>
                        </div>
                    }
                    @if (canEditField('priority')) {
                        <div class="dropdown-item d-flex justify-content-between" (click)="runAction('priority', elementData.priority)">
                            <div>
                                <i class="fa-regular fa-chevrons-up"></i><span>{{ 'RESOURCES.' + getCleanResourceId() + '.fields.priority.label' | locTranslate  }}</span>
                            </div>
                            <div>
                                <b class="ps-3">{{ getPriorityLabel(elementData.priority) || '-' }}</b>
                            </div>
                        </div>
                    }
                    @if (resourceId == 'File' && canEditField('license')) {
                        <div class="dropdown-item d-flex justify-content-between" (click)="runAction('license', elementData.license)">
                            <div>
                                <i class="fa-regular fa-certificate"></i><span>{{ 'RESOURCES.' + getCleanResourceId() + '.fields.license.label' | locTranslate  }}</span>
                            </div>
                            <div>
                                <b class="ps-3">{{ elementData.license || '-' }}</b>
                            </div>
                        </div>
                    }
                    @if (actions.user) {
                        <div class="dropdown-item d-flex justify-content-between" (click)="runAction('user', elementData.user_id)">
                            <div>
                                <i class="fa-regular fa-user"></i><span>{{ 'RESOURCES.' + getCleanResourceId() + '.fields.user_id.label' | locTranslate  }}</span>
                            </div>
                            <div>
                                <b class="ps-3">{{ formatUserLabel(elementData.user_id, elementData.user) || '-' }}</b>
                            </div>
                        </div>
                    }
                    @if (actions.group) {
                        <div class="dropdown-item d-flex justify-content-between" (click)="runAction('group', elementData.group_id)">
                            <div>
                                <i class="fa-regular fa-users"></i><span>{{ 'RESOURCES.' + getCleanResourceId() + '.fields.group_id.label' | locTranslate  }}</span>
                            </div>
                            <div>
                                <b class="ps-3">{{ getGroupLabel(elementData.group_id) || '-' }}</b>
                            </div>
                        </div>
                    }
                    @if (canActionRealm()) {
                        <div class="dropdown-item" (click)="runAction('realm', elementData.realm_id)">
                            <div>
                                <div class="d-flex justify-content-between">
                                    <div>
                                        <i class="fa-regular fa-castle"></i><span>{{ 'RESOURCES.' + getCleanResourceId() + '.fields.realm_id.label' | locTranslate  }}</span>
                                    </div>
                                    <div>
                                        <b class="ps-3">{{ getRealmLabel(elementData.realm_id) || '-' }}</b>
                                    </div>
                                </div>
                                @if (hasChangeRealmWarning()) {
                                    <div class="mt-1">
                                        <small class="alert alert-warning m-0 px-2 py-1 text-wrap">{{ 'pg-resource-element-menu.warning-change-realm' | locTranslate }}</small>
                                    </div>
                                }
                            </div>
                        </div>
                    }
                </div>
            }
        </div>
    </div>
}
